export const NOTICE_TYPE = {
    user: 1, // 客户端
    merchant: 2, // 客户端
};

export const WECHAT_PLATFORM = {
    wechatMp: "wechatMp", // 微信小程序
    wechatApp: "wechatApp", // 微信app
};

export const BILL_TYPE = {
    income: 1, // 收入
    incoming: 0, // 入账中
    expenditure: -1, // 支出
};

export const BILL_Kind = {
    recharge: "recharge", // 充值
    testUser: "testUser", // 测试用户
    registerGive: "registerGive", // 注册赠送
    subscriptionFee: "subscriptionFee", // 认购手续费
    storeFee: "storeFee", // 商城手续费
    storeFeeReward: "storeFeeReward", // 商城手续费奖励
    subscriptionFeeRefund: "subscriptionFeeRefund", // 认购手续费退款
    orderRefund: "orderRefund", // 订单退款
    extractCashFail: "extractCashFail", // 提现失败金额返回
    noAuctionReward: "noAuctionReward", // 拍不到奖励
    noAuctionShareReward: "noAuctionShareReward", // 拍不到分享奖励
    merchantUpgradeBase: "merchantUpgradeBase", // 邀请商铺升级孵化基地奖励
    merchantUpgradeCenter: "merchantUpgradeCenter", // 邀请商铺升级孵化中心奖励
    freezeBond: "freezeBond", // 竞拍商品保证金冻结
    unfreezeBond: "unfreezeBond", // 竞拍商品保证金解冻
    freezeDeduction: "freezeDeduction", // 保证金抵扣
    userUpgrade: "userUpgrade", // 邀请用户升级市场运营服务机构
    userExtractCash: "userExtractCash", //  用户余额提现
    merchantExtractCash: "merchantExtractCash", //  店铺余额提现
    orderFinalPAY: "orderFinalPAY", //  订单尾款支付
    auctionSpu: "auctionSpu", //  拍品购买收入

    subscriptionConsume: "subscriptionConsume", // 认购额度消费
    subscriptionRefund: "subscriptionRefund", // 认购商品退款
    subscriptionOrderRelease: "subscriptionOrderRelease", // 认购额订单释放
    latestReleaseSubscriptionFreeze: "latestReleaseSubscriptionFreeze", // 上次订单认购额未使用完部分冻结
    adminGetSubscription: "adminGetSubscription", //  管理获得认购额
    subscriptionOrderReward: "subscriptionOrderReward", // 竞拍订单奖励
    subscriptionOrderFreeze: "subscriptionOrderFreeze", // 竞拍订单冻结
    subscriptionFeeReward: "subscriptionFeeReward",

    // contributionConsume: "subscriptionConsume", // 贡献值消费
    storeBuy: "storeBuy", // 兑换商城购买商品
    storeRefund: "storeRefund", // 兑换商城购买商品退款

    // auctionGetSubscription: "auctionGetSubscription", //  竞拍成功获得全网认购额
    // subscriptionBuy: "subscriptionBuy", // 个品认购商品购买
    // subscriptionRefund: "subscriptionRefund", // 个品认购商品退款

    // productGetSubscription: "productGetSubscription", //  竞拍成功获得标品认购额
    // productSubscriptionBuy: "productSubscriptionBuy", //  标品认购商品购买
    // productSubscriptionRefund: "productSubscriptionRefund", //  标品认购商品退款

    userPremiumIncome: "userPremiumIncome", // 竞拍成交差价奖励
    userTransactionReward: "userTransactionReward",
    inviteShareReward: "inviteShareReward",
    userTransactionDeduct: "userTransactionDeduct",

    merchantPremiumIncome: "merchantPremiumIncome", // 商铺竞拍差价收入
    merchantSpuIncome: "merchantSpuIncome", // 商铺商品售卖收入
    listingFee: "listingFee", // 竞拍手续费
    inviteAuctionFee: "inviteAuctionFee", // 邀约竞拍手续费

    manageFee: "manageFee", //  平台管理费
    earnestMoney: "earnestMoney", // 授权服务费
    defaultOrderIncome: "defaultOrderIncome", // 平台拍卖订单违约收益
    systemPremiumIncome: "systemPremiumIncome", // 平台溢价收入
    merchantBaseOwn: "merchantBaseOwn", //  拍品是基地自有的，基地获得拍品差价的10%
    serverFee: "serverFee", //  拍品是基地自有的，基地获得拍品差价的10%
    baseRelationUser: "baseRelationUser", //  孵化基地关联会员收益
    partnertRelationUser: "partnertRelationUser", //  市场运营服务机构关联会员收益
    partnertAndBaseRelationUserStat: "partnertAndBaseRelationUserStat", //  孵化基地/市场运营服务机构关联会员差价统计
    merchantApplyAward: "merchantApplyAward", // 下级申请店铺成功奖励
    orderDefault: "orderDefault", // 订单违约

    auctionOffer: "auctionOffer", // 竞拍出价
    auctionOfferOut: "auctionOfferOut", // 竞拍出价被超越
    auctionShareAward: "auctionShareAward", // 成交分享奖励
    auctionShareAwardDeduct: "auctionShareAwardDeduct", // 成交分享奖励支出
};



export const NOTICE_SOURCE = { // 消息来源
    noLink: "noLink", // 不跳转
    // sku: "sku", // 商品规格详情
    auctionSku: "auctionSku", // 拍品详情
    subscriptionSku: "subscriptionSku", // 认购详情
    storeSpu: "storeSpu", // 兑换商品详情
    userInvite: "userInvite", // 下级列表
    auctionHouse: "auctionHouse", // 用户拍间列表
    userBill: "userBill", // 用户账单列表
    merchantBill: "merchantBill", // 店铺账单列表
    merchantSpu: "merchantSpu", // 商铺拍品列表
    merchantDetail: "merchantDetail", // 商铺申请详情
    userOrderDetail: "userOrderDetail", // 用户订单详情
    userDeliveryDetail: "userDeliveryDetail", // 用户物流详情
    merchantDeliveryDetail: "merchantDeliveryDetail", // 商铺物流详情
    merchantIndex: "merchantIndex", // 商户首页
    userPersonal: "userPersonal", // 用户中心
    room: "room", // 聊天列表
};

export const NOTICE_CLASSIFY = { // 消息分类
    systemPush: "systemPush", // 系统通知
    auctionMessage: "auctionMessage", // 拍卖消息
    newSpuAuction: "newSpuAuction", // 新品开拍
    deliveryMessage: "deliveryMessage", // 物流交易
    accountMessage: "accountMessage", // 账户提醒
    messagePush: "messagePush", // 消息通知
};

export const NOTICE_KIND = { // 消息类型
    smsVerify: "smsVerify", // 短信验证
    realVerify: "realVerify", // 实名认证
    merchantAuditFailure: "merchantAuditFailure", // 卖家审核失败
    merchantAuditSuccess: "merchantAuditSuccess", // 卖家审核成功
    spuAuditFailure: "spuAuditFailure", // 拍品审核失败
    spuAuditSuccess: "spuAuditSuccess", // 拍品审核成功
    auctionHouseAuditFailure: "auctionHouseAuditFailure", // 拍间审核失败
    auctionHouseAuditSuccess: "auctionHouseAuditSuccess", // 拍间审核成功

    auctionBeOutdone: "auctionBeOutdone", // 拍品被抢拍
    finalPay: "finalPay", // 拍品尾款付款提醒
    notFinalPay: "notFinalPay", // 拍品尾款未付款违约通知
    auctionNearEnd: "auctionNearEnd", // 拍卖快结束提醒

    newSpuAuction: "newSpuAuction", // 开拍前提醒

    sendMessage: "sendMessage", // 发货通知
    deliveryMessage: "deliveryMessage", // 派送通知
    urgeSendMessage: "urgeSendMessage", // 催发货通知

    rechargeBalance: "rechargeBalance", // 充值余额
    freezeBalance: "freezeBalance", // 冻结余额

    unfreezeBalance: "unfreezeBalance", // 解冻余额
    extractCashAudit: "extractCashAudit", // 提现审核
    extractCashFailure: "extractCashFailure", // 提现失败
    extractCashSuccess: "extractCashSuccess", // 提现成功
    shareSuccess: "shareSuccess", // 分享成功
    shareAuction: "shareAuction", // 分享参拍
    incomeMessage: "incomeMessage", // 收益推送
    merchantMessage: "merchantMessage", // 卖家消息
    getSubscriptionIncome: "getSubscriptionIncome", // 获得认购收益权推送
    expendSubscriptionIncome: "expendSubscriptionIncome", // 消耗认购权
    expendContribution: "expendContribution", // 消耗贡献值
    merchantPayEarnestMoney: "merchantPayEarnestMoney", // 店铺保证金缴纳
    merchantEarnestMoneyDeduct: "merchantEarnestMoneyDeduct", // 店铺保证金扣费
    authorizedServiceFee: "authorizedServiceFee", // 授权服务费缴纳
    newUserRegister: "newUserRegister", // 新用户注册
    userUpgrade: "userUpgrade", // 用户升级市场运营服务机构

    userAuctionTimeOut1: "userAuctionTimeOut1", // 认购转拍流拍1次，认购单提示：
    userAuctionTimeOut2: "userAuctionTimeOut2", // 认购转拍流拍2次，认购单提示：
    chatMessage: "chatMessage", // 互动消息
};

export const NOTICE_WXTEMPLATE = {
    template1: {
        templateId: "zy2F-GqbmvQlu2K_a0P8UVChyxFvE4x71K4Yg0ocxzs",
        templateContent: `{{first.DATA}}
      订单编号：{{keyword1.DATA}}
      服务人员：{{keyword2.DATA}}
      联系电话：{{keyword3.DATA}}
      {{remark.DATA}}`,
    },
    merchantAuditFailure: {
        templateId: "W1_amYrxnlkGX4MB9z1zTiX_I5xPpV-cXUtG3lAtV4I",
        templateContent: `{{first.DATA}}
      姓名：{{keyword1.DATA}}
      会员编号：{{keyword2.DATA}}
      手机号码：{{keyword3.DATA}}
      审核时间：{{keyword4.DATA}}
      {{remark.DATA}}`,
    },
    spuAuditFailure: {
        templateId: "rKukKPdb-XB2_HlFfeMs0JtMCY47e9bGmMNlNPc676g",
        templateContent: `{{first.DATA}}
      商品名称：{{keyword1.DATA}}
      价格：{{keyword2.DATA}}
      审核原因：{{keyword3.DATA}}
      审核时间：{{keyword4.DATA}}
      {{remark.DATA}}`,
    },
    spuAuditSuccess: {
        templateId: "rKukKPdb-XB2_HlFfeMs0JtMCY47e9bGmMNlNPc676g",
        templateContent: `{{first.DATA}}
      姓名：{{keyword1.DATA}}
      会员编号：{{keyword2.DATA}}
      手机号码：{{keyword3.DATA}}
      审核时间：{{keyword4.DATA}}
      {{remark.DATA}}`,
    },
    auctionBeOutdone: {
        templateId: "9aXGf2kv_MiZJ9WdyvLn56EK-XfE8eInFfBtqJV96XE",
        templateContent: `{{first.DATA}}
      拍品：{{keyword1.DATA}}
      您的出价：{{keyword2.DATA}}
      最新出价：{{keyword3.DATA}}
      时间：{{keyword4.DATA}}
      {{remark.DATA}}`,
    },
    finalPay: {
        templateId: "fXl7O0x9qk7GgzWujygIK4RbpvqqebCTuy-sw_OeSIc",
        templateContent: `{{first.DATA}}
      订单号：{{keyword1.DATA}}
      订单总金额：{{keyword2.DATA}}
      账户余额：{{keyword3.DATA}}
      还需支付：{{keyword4.DATA}}
      {{remark.DATA}}`,
    },
    notFinalPay: {
        templateId: "JoELEZpDeFiT3SsUqtfRgZ-Osl5WQAHOQCDd14iBANs",
        templateContent: `{{first.DATA}}
      订单号：{{keyword1.DATA}}
      到期时间：{{keyword2.DATA}}
      {{remark.DATA}}`,
    },
    newSpuAuction: {
        templateId: "K2CLt5cWbe8mtk-LJaTCMDpSAdFbE6kahTyBqzofD8w",
        templateContent: `{{first.DATA}}
      会员姓名：{{keyword1.DATA}}
      资产包编号：{{keyword2.DATA}}
      拍卖时间：{{keyword3.DATA}}
      {{remark.DATA}}`,
    },
    sendMessage: {
        templateId: "RieyPPmTfv2cHHpZGGNIejEzNIxOiH0VdJ4w98mNLic",
        templateContent: `{{first.DATA}}
      订单编号：{{keyword1.DATA}}
      商品名称：{{keyword2.DATA}}
      配送商名称：{{keyword3.DATA}}
      {{remark.DATA}}`,
    },
    deliveryMessage: {
        templateId: "bJfIGysL0owxCT4_sGr6CgSJGKHFSEkp_lCUR558r6M",
        templateContent: `{{first.DATA}}
      订单金额：{{keyword1.DATA}}
      商品详情：{{keyword2.DATA}}
      收货地址：{{keyword3.DATA}}
      开始配送时间：{{keyword4.DATA}}
      订单编号：{{keyword5.DATA}}
      {{remark.DATA}}`,
    },
    rechargeBalance: {
        templateId: "Dex0gqEsVWV7-Et4OMr4yig6uPLusllbbTNDzSRM09k",
        templateContent: `{{first.DATA}}
      充值账户：{{keyword1.DATA}}
      充值金额：{{keyword2.DATA}}
      充值方式：{{keyword3.DATA}}
      充值时间：{{keyword4.DATA}}
      {{remark.DATA}}`,
    },
    extractCashAudit: {
        templateId: "eYlKlVfT3NiQvfarvcBxJWx_KKt4JPIpVJXldxctbGY",
        templateContent: `{{first.DATA}}
      提现金额：{{keyword1.DATA}}
      申请时间：{{keyword2.DATA}}
      审核状态：{{keyword3.DATA}}
      原因说明：{{keyword4.DATA}}
      {{remark.DATA}}`,
    },
    extractCashFailure: {
        templateId: "eYlKlVfT3NiQvfarvcBxJWx_KKt4JPIpVJXldxctbGY",
        templateContent: `{{first.DATA}}
      提现金额：{{keyword1.DATA}}
      申请时间：{{keyword2.DATA}}
      审核状态：{{keyword3.DATA}}
      原因说明：{{keyword4.DATA}}
      {{remark.DATA}}`,
    },
    extractCashSuccess: {
        templateId: "pY0SrhzmYVFNwoBqpbhs5mMnL-lbX1vlzIrV-nbEF0U",
        templateContent: `{{first.DATA}}
      订单号：{{keyword1.DATA}}
      到期时间：{{keyword2.DATA}}
      {{remark.DATA}}`,
    },
    authorizedServiceFee: {
        templateId: "Dex0gqEsVWV7-Et4OMr4yig6uPLusllbbTNDzSRM09k",
        templateContent: `{{first.DATA}}
      充值账户：{{keyword1.DATA}}
      充值金额：{{keyword2.DATA}}
      充值方式：{{keyword3.DATA}}
      充值时间：{{keyword4.DATA}}
      {{remark.DATA}}`,
    },
};


export const USER_STATUS = {
    normal: 1,
    black: 2,
    logout: 3,
};

export const USER_LEVEL = {
    vip: 11,
    partner: 21,
};

export const USER_ALLOWPAYMENT = {
    open: 1,
    notOpen: 0,
};

export const SMS_KIND = {
    // register: 1,
    login: 2, // 注册和登录
    findPass: 3, // 找回密码
    setPayPass: 4, // 设置支付密码
    createBankCard: 5, // 银行卡绑定
    bindPhone: 6, // 手机号绑定
    updatePhoneOld: 7, // 手机号修改老手机号
    updatePhoneNew: 8, // 手机号修改新手机号
};



export const EXTRACTCASH_STATUS = {
    wait: 0, // 等待审核
    success: 1, // 审核通过
    refuse: 2, // 审核不通过
    waitReceipt: 21, // 待确认微信收款
    remit: 3, // 打款成功
};

export const EXTRACTCASH_TYPE = {
    user: 1, // 用户提现
    merchant: 2, // 商家提现
};

export const REMIT_TYPE = {
    bank: "bank", // 银行卡提现
    wx: "wx", // 微信提现
    ali: "ali", // 支付宝
};


export const STAT__KIND = {
    download: "download", // 下载
    register: "register", // 注册
    login: "login", // 登录
    offer: "offer", // 竞拍
    oneOffer: "oneOffer", // 个品竞拍
    productOffer: "productOffer", // 标品竞拍
    shareAuction: "shareAuction", // 分享拍品
    shareAuctionHouse: "shareAuctionHouse", // 分享拍间
    invitePoster: "invitePoster", // 邀请海报
    shareBind: "shareBind", // 分享绑定
    bindOffer: "bindOffer", // 绑定参拍
    subscription: "subscription", // 认购
    contribution: "contribution", // 贡献值
    subscriptionResell: "subscriptionResell", // 认购转拍
    auctionResell: "auctionResell", // 拍间转拍
    orderSend: "orderSend", // 发货
    validResell: "validResell", // 有效转拍
};

export const SPU_STATUS = { // 拍品状态
    fail: -10, // 审核失败
    audit: 0, // 审核中
    success: 10, // 审核成功
    waitStart: 20, // 等待开始
    auctionStart: 100, // 拍卖中 认购中  标品竞拍中  用户转拍拍卖中 商城商品售卖汇总
    auctionEnd: 110, // 拍卖结束 已认购  标品竞拍结束 用户转拍拍卖结束 商城商品下架
    auctionTimeOut: 120, // 流拍 认购到期  标品竞拍流拍  用户转拍流拍
    down: -20, // 已下架
    del: -100, // 删除
};

export const SPU_SORT = {
    default: 100, // 竞拍
    mt3ts: 90, // 超过3倍
};

export const SPU_TYPE = {
    auction: 10, // 商家拍卖
    subscription: 20, // 商家认购转拍
    userAction: 30, // 认购转拍
    store: 40, // 商城商品
    invite: 50, // 邀约专区
};

export const SPU_KIND = {
    one: 10, // 个品拍卖
    product: 20, // 标品拍卖
};

export const SPU_FLAG = {
    collective: 10, // 个品拍卖
};

export const USERBANKCARD_TYPE = {
    user: 1,
    merchant: 2,
};

export const SKUOFFER_STATUS = {
    success: 1,
    fail: -1,
};

export const MERCHANT_KIND = {
    auction: 1,
    store: 2,
};

export const MERCHANT_STATUS = { // 1 审核中 2 通过 3 拒绝
    check: 1,
    pass: 2,
    refuse: 3,
    applyClose: 21, // 申请退店
    closed: 22, // 已退店 
    refundClose: 23, // 拒绝退店 
};

export const MERCHANT_EARNESTPAY = {
    pay: 1,
    notPay: 0,
};

export const MERCHANT_OPENROBOT = {
    open: 1,
    notOpen: 0,
};

export const MERCHANT_SHOPLEVEL = { // 11 店铺 21 孵化体验中心 31 供应链
    shop: 11,
    incubationCenter: 21,
    incubationBase: 31,
};



// wxApp 微信APP支付 balance 余额支付
export const PAY_TYPE = {
    wxApp: "wxApp",
    wxMp: "wxMp",
    balance: "balance",
    aliApp: "aliApp", // 支付宝app
    contribution: "contribution", // 贡献值支付
    balanceAndContribution: "balanceAndContribution", // 贡献值和余额混合支付
};

export const PRICEDETAIL_KIND = {
    auction: "auction", // 竞拍价格
    subscription: "subscription", // 认购价格
    bondDeduct: "bondDeduct", // 保证金价格
    auctionOfferDeduct: "auctionOfferDeduct", // 竞拍出价抵扣
    deliveryFee: "deliveryFee", // 物流价格
    merchantApply: "merchantApply", // 商铺授权费
    recharge: "recharge", // 充值
};

// 10 待付款 20 已支付 30 待发货 40 已发货（待收货） 50 转拍  100 已完成 101 已完成（转拍） -1 已取消 -100 已关闭
export const ORDER_STATUS = {
    wait: 10, // 待付款
    pay: 20, // 已支付
    waitSend: 30, // 待发货
    send: 40, // 已发货（待收货）
    resell: 50, // 用户认购转卖
    refundApply: 60, // 售后申请
    refundWaitSend: 61, // 等买家退货
    refundSend: 62, // 等商家收货确认
    refundRefuse: 63, // 商家拒绝退货
    complete: 100, // 已完成
    reselled: 101, // 已完成（转拍） // @TODO: 没有使用，后面删除
    subscriptionComplete: 102, // 已完成（认购已转拍成功）
    cancel: -1, // 已取消
    close: -100, // 已关闭
};

// 10 充值 20 竞拍 30 用户竞拍 40 认购 50 商家授权服务费 60 拍间竞拍
export const ORDER_TYPE = {
    recharge: 10, // 充值
    auction: 20, // 竞拍
    invite: 21, // 邀约竞拍
    userAuction: 30, // 用户竞拍
    subscription: 40, // 认购
    store: 45, // 商城商品
    shopEarnestMoney: 50, // 商家授权服务费
    auctionHouseAuction: 60, // 拍间竞拍
};

export const ORDER_KIND = {
    one: 10, // 个品竞拍
    product: 20, // 标品竞拍
};

export const TRAIN__STATUS = {
    enable: 1, // 启动
    disable: 0, // 关闭
};

export const COOPERATOR_STATUS = {
    enable: 1, // 启动
    disable: 0, // 关闭
};


export const RELATIONUSERMONTH_TYPE = {
    partner: 1,
    base: 2,
};

// 0 收益中 10 代打款 20 已打款
export const RELATIONUSERMONTH_STATUS = {
    incoming: 0,
    waitPay: 10,
    pay: 20,
};

export const COLLECT_TYPE = {
    merchant: 10,
};

export const Category_TYPE = {
    auction: 1,
    store: 2,
};

